import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuUser from '../submenu/SubmenuUser'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import UserSettingsForm from './form/UserSettingsForm'
import { useState } from 'react'
import { useEffect } from 'react'
import { getUserSettingsAPI } from '../../../api/user/userAPI'
import { responseError } from '../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import MySpiner from '../../UI/spiner/MySpiner'

const UserSettings = () => {

    const [settings, setSettings] = useState({})

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getSettings()
    }, [])

    const getSettings = () => {
        setLoading(true)
        getUserSettingsAPI().then(data => {
            setSettings(data)
            setLoading(false)
        }).catch(e => {
            setLoading(false)
            setError(responseError(e))
        })
    }

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuUser />
		</MyBlock>
        <MyBlockHeader
            header={'Налаштування профілю'}
            // isBack={true}
            // options={
            //     <UserInfoOptions />
            // }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
            {
                loading ?
                    <MySpiner />
                :
                error ?
                    <ErrorMessage error={error} />
                :
                    <UserSettingsForm 
                        settingsBd={settings}
                    />
            }
		</MyBlock>
    </LayoutMain>
  )
}

export default UserSettings